import React, { Component } from 'react';
import axios from 'axios';
import Table from '~/components/Table';
import Spinner from '~/components/Spinner';
import { players_heads, goalies_heads} from '~/tools/mll/headers';
import { combineNames } from '~/tools/mll/helpers';
import './styles.scss';

class TeamStats extends Component {
  state = {
    players: [],
    goalies: [],
    headers: [players_heads, goalies_heads],
    loaded: false,
    items: this.props.data && this.props.data.metadataMap
  }

  componentDidMount = () => {
    const { items } = this.state
    axios.get(`/team-roster-standing/${items.teamId}/${items.seasonId}`)
    .then((res) => {
      const roster = res.data.rosters.teamroster.team;
      const inital_p = roster.players.player;
      const inital_g = roster.goalies.goalie;
      const [players, goalies] = combineNames([inital_p, inital_g], 'firstname', 'lastname');
      this.setState({
        players: players,
        goalies: goalies,
        team: roster.teamname,
        loaded: true
      })
    }).catch((err) => {
      console.log(err);
    });
  }

  render() {
    return (
      <div className="teamstats">
        <div className='teamstats-title site-border-color'>
          {`${new Date().getFullYear()} ${this.state.team || ''} Statistics`}
        </div>
          { this.state.loaded ? 
            ['players', 'goalies'].map((el, index) => (
              <Table 
                key={index}
                headers={this.state.headers[index][0]}
                data={this.state[el]}
                values={this.state.headers[index][1]}
                sortBy={[['PTS', 'points'], ['GA', 'saves']][index]}
                length={this.state[el].length}
              />           
            ))
          : <Spinner /> }
      </div>
    );
  }
}

export default TeamStats;
